module.exports = __webpack_public_path__ + "static/media/phila_grill.9a233a4c.webp";